import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Select, message, Spin } from 'antd'
import { SGeneralForms } from 'shj-components'
import {getRegionLists, getAllCompany, getAllCompanyMrn, httpCompanyList} from "@/services/customerServices";
const { Option } = Select;
export const AddOrEditForm = (props: any) => {
  const { editData } = props
  const formRef: any = useRef()
  const [companyMrnList, setCompanyMrnList] = useState([] as any)
  const [spinning, setSpinning] = useState(false)
  const reqMeg = '不能为空'
  useEffect(() => {
    initFn()
  }, [])

  const initFn = async () => {
    setSpinning(true)
    if (editData) {
      // let code:any = []
      // if(editData.provinceCode){
      //   code.push(editData.provinceCode)
      // }
      // if(editData.cityCode){
      //   code.push(editData.cityCode)
      // }
      // if(editData.countyCode){
      //   code.push(editData.countyCode)
      // }
      getMrn(editData.companyId)
      formRef.current?.onFormRef()?.setFieldsValue({...editData})
      setSpinning(false)
    }
  }

  const getOptions = async () => {
    const companyList = await httpCompanyList({})
    const regionTreeList = await getRegionLists()
    return Promise.resolve({
      companyList: companyList,
      regionTreeList: regionTreeList,
    })
  }
  const onChangeCompany = async (val) => {
    getMrn(val)
    formRef.current?.onFormRef()?.setFieldsValue({ dispatchUserId: '' })
  }
  const getMrn = async(val) => {
    const companyMrn = await getAllCompanyMrn({ directlyUnder: { orgId: val, includeChild: true } })
    setCompanyMrnList(companyMrn)
  }
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        layout={'vertical'}
        httpOptionsFn={getOptions}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '城市',
                name: 'cityCode',
                spanCol: 24,
                type: 'select',
                data: 'regionTreeList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'regionCode', label: 'regionName' },
                },
              },
              {
                label: '门店',
                name: 'companyId',
                spanCol: 24,
                type: 'select',
                data: 'companyList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'orgId', label: 'companyName' },
                  onChange: onChangeCompany
                },
              },
              {
                label: '选择门店/分配人',
                name: 'dispatchUserId',
                spanCol: 24,
                type: 'select',
                required: true,
                children: <Select placeholder={'请选择分配人'}>
                  {companyMrnList.map((item: any) => (
                    <Option key={item.ucenterUserId} value={item.ucenterUserId}>
                      {item.userName}
                    </Option>
                  ))}
                </Select>
              },
            ],
          },
        ]}
      />
    </Spin>
  )
}
